import { render, staticRenderFns } from "./statementDetails.vue?vue&type=template&id=c429f4c4&"
import script from "./statementDetails.vue?vue&type=script&lang=js&"
export * from "./statementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports